// extracted by mini-css-extract-plugin
export default {"carousel":"EL-z"};